import { all, takeEvery, takeLatest, call, apply, put } from 'redux-saga/effects';

import {
    ATTEMPT_FETCH_ATHLETE_SESSIONS,
    FETCH_ATHLETE_SESSIONS_SUCCEEDED,
    ATTEMPT_FETCH_SESSION_DETAILS,
    FETCH_SESSION_DETAILS_SUCCEEDED,
} from 'shared_redux/actions';
import API from 'services/athlete_sessions';
import { handleError } from 'services/alerts';

export default function* AthleteSessionsSaga() {
    yield all([
        takeLatest(ATTEMPT_FETCH_ATHLETE_SESSIONS, fetchAthleteSessions),
        takeLatest(ATTEMPT_FETCH_SESSION_DETAILS, fetchSessionDetails),
    ]);
};

function *fetchAthleteSessions(action) {
    try {
        const sessions = yield apply(API, API.getAthleteSessions, [action.athleteId, action.summary]);
        yield put({
            type: FETCH_ATHLETE_SESSIONS_SUCCEEDED,
            athleteId: action.athleteId,
            payload: sessions,
        });
    } catch(error) {
        yield handleError(error, 'Error: Unable to fetch athlete sessions: ' + error);
    }
}

function *fetchSessionDetails(action) {
    try {
        const sessionDetails = yield apply(API, API.getAthleteSessionDetails, [action.athleteId, action.sessionId]);
        yield put({
            type: FETCH_SESSION_DETAILS_SUCCEEDED,
            athleteId: action.athleteId,
            sessionId: action.sessionId,
            payload: sessionDetails,
        });
    } catch(error) {
        yield handleError(error, 'Error: Unable to fetch session details: ' + error);
    }
}
